import React from 'react'
import Pt from 'prop-types'
import Mpt from 'react-moment-proptypes'
import moment from 'moment'

/**
 * @deprecated Use Components from Time.
 */
export default function Duration({
  asMonths = false,
  className,
  duration,
  humanize = false,
  now = moment(),
  showOne = false,
}) {
  if (humanize && moment.isMoment(duration)) {
    return (
      <span className={className}>
        {duration.from(now)}
      </span>
    )
  }

  if (!moment.isDuration(duration)) {
    duration = moment.duration(now.diff(duration))
  }

  if (humanize) {
    return (
      <span className={className}>
        {duration.humanize()}
      </span>
    )
  }

  const durationMonths = duration.asMonths()
  const moreThanYear = durationMonths >= 12 && !asMonths

  const word = moreThanYear ? 'year' : 'month'
  const numWords = moreThanYear
    ? Math.round((durationMonths / 12) * 10) / 10
    : Math.round(durationMonths * 10) / 10

  return (
    <span className={className}>
      {(showOne || numWords !== 1) && `${numWords} `}{word}{numWords !== 1 && 's'}
    </span>
  )
}

Duration.propTypes = {
  asMonths: Pt.bool,
  className: Pt.string,
  duration: Pt.oneOfType([
    Mpt.momentObj,
    Mpt.momentDurationObj,
  ]).isRequired,
  humanize: Pt.bool,
  now: Pt.instanceOf(moment),
  showOne: Pt.bool,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Duration.jsx